module.exports = __webpack_public_path__ + "static/media/ring.624c3d55.svg";